import { useEffect } from "react";

const SITE_URL = "https://freedomdetailpa.com";

const setMeta = (name, content) => {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const useSeo = ({ title, description, path = "/", robots = "index, follow" }) => {
  useEffect(() => {
    document.title = title;
    if (description) setMeta("description", description);
    setMeta("robots", robots);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${SITE_URL}${path}`);
  }, [title, description, path, robots]);
};
